import Hero from "../components/Home/Hero";
import HomeFeaturedProducts from "../components/Home/HomeFeaturedProducts";
import HomeSecondSection from "../components/Home/HomeSecondSection";
import HomeSubscribe from "../components/Home/HomeSubscribe";
import HomeThirdSection from "../components/Home/HomeThirdSection";
import TrustedCustomers from "../components//Home/TrustedCustomers";

const Home = () => {
  return (
    <div>
      <Hero />
      <HomeSecondSection />
      <HomeThirdSection />
      <HomeFeaturedProducts />
      <TrustedCustomers />
      <HomeSubscribe />
    </div>
  );
};

export default Home;
